import React from 'react';

const AdminHeader = ({ user, onMenuToggle, onLogout }) => {
  const [fullscreen, setFullscreen] = React.useState(Boolean(document.fullscreenElement));

  React.useEffect(() => {
    const handleFullscreenChange = () => setFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    }
  };

  const openPublicWebsite = () => {
    window.open(`${window.location.origin}/`, '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="admin-header">
      <button type="button" className="admin-mobile-menu" onClick={onMenuToggle} aria-label="Ouvrir le menu">
        <i className="fa fa-bars" aria-hidden="true" />
      </button>
      <div className="admin-header-title">
        <span className="admin-eyebrow">ESPACE ADMINISTRATEUR</span>
        <strong>Gestion du mariage</strong>
      </div>
      <div className="admin-header-actions">
        <div className="admin-header-tools">
          <button type="button" className="admin-header-icon-button" onClick={toggleFullscreen} title={fullscreen ? 'Quitter le plein écran' : 'Plein écran'} aria-label={fullscreen ? 'Quitter le plein écran' : 'Plein écran'}>
            <i className={`fa fa-${fullscreen ? 'compress' : 'expand'}`} aria-hidden="true" />
          </button>
          <button type="button" className="admin-header-icon-button" onClick={openPublicWebsite} title="Ouvrir le site public" aria-label="Ouvrir le site public">
            <i className="fa fa-globe" aria-hidden="true" />
          </button>
        </div>
        <div className="admin-user-summary">
          <span className="admin-avatar">{(user.name || 'A').charAt(0).toUpperCase()}</span>
          <span><strong>{user.name}</strong><small>{user.role}</small></span>
        </div>
        <button type="button" className="admin-logout-button" onClick={onLogout}>
          <i className="fa fa-sign-out" aria-hidden="true" /> Déconnexion
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
